class UiNodesController
  @updateOptionsForConfiguration: (url) ->
    selectors =
      mainboard: "#ui_node_mainboard"
      old_mainboard: "#old_mainboard"
      power_source_a: "#ui_node_power_source_a"
      power_source_b: "#ui_node_power_source_b"

    UiNodePowerConfigurationsController.updateOptionsForConfiguration(url, selectors)

$(document).ready ->
  $(document).on('change', '.uin_controlled_elements', (event) ->
    UiNodesController.updateOptionsForConfiguration($(this).data('url'))
  )

module.exports = UiNodesController
